import { render, staticRenderFns } from "./MonthTitle.vue?vue&type=template&id=70ec5c3c&scoped=true&"
import script from "./MonthTitle.vue?vue&type=script&lang=ts&"
export * from "./MonthTitle.vue?vue&type=script&lang=ts&"
import style0 from "./MonthTitle.vue?vue&type=style&index=0&id=70ec5c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec5c3c",
  null
  
)

export default component.exports